// 발급 이력 유형·상태 필터 줄 (발급 현황 · Self 탭 공용). 선택지 키는 filterIssueHistory 와 동일.
import React from 'react';
import { Translate as t } from '../../config/Translate';
import { FILTER_ROW_CLASS } from './PeriodFilter';

// leading: 선택 — 유형·상태 앞(왼쪽)에 같은 줄로 놓을 컨트롤(기간, 법인, 하위 조직 등).
// note: 선택 — 줄 맨 끝에 작게 붙일 안내(필터·버튼 아님, 예: 조회 전용 안내).
const IssueHistoryFilters = ({ typeFilter, onTypeChange, statusFilter, onStatusChange, leading = null, note = null }) => (
    <div className={FILTER_ROW_CLASS}>
        {leading}
        <select
            className="form-select form-select-sm w-auto"
            value={typeFilter}
            onChange={(e) => onTypeChange(e.target.value)}
            aria-label={t('common.field.type')}
        >
            <option value="all">{t('common.field.type')}: {t('common.label.all')}</option>
            <option value="initial">{t('license.label.initial')}</option>
            <option value="renewal">{t('license.label.renewal')}</option>
        </select>
        <select
            className="form-select form-select-sm w-auto"
            value={statusFilter}
            onChange={(e) => onStatusChange(e.target.value)}
            aria-label={t('common.label.status')}
        >
            <option value="all">{t('common.label.status')}: {t('common.label.all')}</option>
            <option value="pending">{t('license.status.pendingActivation')}</option>
            <option value="activated">{t('license.status.activated')}</option>
        </select>
        {note && <div className="ms-auto d-flex align-items-center gap-2">{note}</div>}
    </div>
);

export default IssueHistoryFilters;
